import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import CustomerChatSvg from 'src/components/icon/CustomerChatSvg';
import cookieUtil from 'src/util/cookieUtil';
import { ECookieName } from 'src/util/utilModel';
import chat100 from 'src/util/chat100';

function WBBLPromo2k25(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const token = cookieUtil.get(ECookieName.COOKIE_TOKEN);

    const openChatBot = async () => {
        const { config: { chat100SiteId, chat100IdAfterLogin, chat100IdBeforeLogin, showChat100Provider } } = theme;
        if (!showChat100Provider) return;

        const isLoggedIn = !!token;
        const chat100CodePlanId = isLoggedIn ? chat100IdAfterLogin : chat100IdBeforeLogin;

        const chat100Data = {
            siteId: chat100SiteId,
            codePlan: chat100CodePlanId
        };

        try {
            await chat100.open(chat100Data);
        } catch (error: any) {
            console.error("Chat100 open failed:", error);
        }
    }

    return (
        <>
            <InformationWrapper>
                <TitleText>
                    <p>Catch the <strong>YOLO247 Logo </strong> During <span className='brandColor'>WBBL & Win {(brandId === 61) ? "$1" : "₹50"} Free Bet!</span></p>
                    <div className='playNowBtn' onClick={openChatBot}>
                        <CustomerChatSvg />
                        <span>Go to Customer chat</span>
                    </div>
                    {(brandId === 61) ? <p>Catch the <strong>YOLO247 logo during any WBBL match</strong> and grab your <strong>$1 Free Bet on Aviator!</strong> <br />
                        <strong>Dont miss out — watch the action, spot the logo, and win instantly!</strong></p> :
                        <p>Catch the <strong>YOLO247 logo during any WBBL match</strong> and grab your <strong>₹50 Free Bet on Aviator!</strong> <br />
                            <strong>Dont miss out — watch the action, spot the logo, and win instantly!</strong></p>}

                    {/* <Link to='/slots/evoplay/uncrossable-rush' className='playNowBtn'>
                        <ClaimNowSvg/>
                        <span>Claim Now</span>
                    </Link> */}
                </TitleText>
                {/* <TitleText>
                    <p>Catch the <strong>YOLO247 logo during any WBBL match</strong> and grab your <strong>₹50 Free Bet on Aviator!</strong> <br />
                    <strong>Dont miss out — watch the action, spot the logo, and win instantly!</strong></p>
                </TitleText> */}
                <ImageWrapper>
                    <Container>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.WBBLFlightImg}`}
                            alt="WBBL"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </Container>
                </ImageWrapper>

                <KeyDetailsSec>
                    <MainTitle>How to participate</MainTitle>
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.WBBLParticipateIcon1}`}
                                alt="WBBL"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Watch any <strong>WBBL (Women's Big Bash League) </strong>match</p>
                        </KeyDetailsSecBox>
                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.WBBLParticipateIcon2}`}
                                alt="WBBL"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Spot the YOLO247 logo </strong>displayed on digital branding during the match broadcast</p>
                        </KeyDetailsSecBox>
                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.WBBLParticipateIcon3}`}
                                alt="WBBL"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Take a clear screenshot or photo </strong>showing the YOLO247 logo.</p>
                        </KeyDetailsSecBox>
                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.WBBLParticipateIcon4}`}
                                alt="WBBL"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Contact Customer Support </strong>on the same day with your screenshot/photo.</p>
                        </KeyDetailsSecBox>
                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.WBBLParticipateIcon5}`}
                                alt="WBBL"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Get a <strong>{(brandId === 61) ? "$1" : "₹50"} Free Bet </strong>on the <strong>Aviator </strong>game!</p>
                        </KeyDetailsSecBox>

                    </KeyDetailsSecWrap>
                </KeyDetailsSec>

                <TermsAndCondition>
                    <MainTitle>Promotion Details</MainTitle>
                    <ul>
                        <li>✪ Promotion valid during the WBBL tournament period.</li>
                        <li>✪ Each player can claim one <strong>{(brandId === 61) ? "$1" : "₹50"} Free Bet per match day.</strong></li>
                        <li>✪ {(brandId === 61) ? "$1" : "₹50"} Free Bet will be given as a <strong>deposit promo code</strong> with additional {(brandId === 61) ? "$1" : "₹50"}</li>
                        <li>✪ Screenshot/photo must clearly show the YOLO247 logo during live broadcast.</li>
                        <li>✪ Rewards will be credited immediately after your deposit using the promo code</li>
                        <li>✪ YOLO247 reserves the right to amend or cancel the offer at any time.</li>
                    </ul>
                </TermsAndCondition>

            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(WBBLPromo2k25));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 1.5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.WBBLMainInnerBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    .brandColor {
        color: ${theme('palette.weeklySepLeaderboardText')};
        font-weight: 700;
    }

    .bgRadial {
        background: ${theme('palette.jiliPlaySpinBgRadial')};
    }

    .playNowBtn {
        width: 314px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 7px;
        color: #000;
        font-size: 16px;
        font-weight: 700;
        text-transform: uppercase;
        margin-bottom: 0.5rem;
        border-radius: 53.178px;
        border: 2.704px solid #FAFF9F;
        background: #E6F01E;
        cursor: pointer;
        transition: background 0.3s ease, border 0.3s ease, transform 0.2s ease-in-out, box-shadow 0.3s ease;

        :hover {
            background: #fff;
            border: 2.704px solid #FAFF9F;
            transform: scale(1.03);
            box-shadow: 0 0 15px #FAFF9F; 
        }

        strong {
            font-weight: 700;
            color: #fff;
        }

    }
`;

const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${theme('palette.liveJackpotTittleTextPadding')};
    position: relative;
    gap: 20px;
    /* margin-bottom: 2rem; */

    p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 186.667% */
        text-transform: capitalize;
        margin: 0;
    }
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    max-width: 1400px;
    margin: 0 auto;

    img {
        width: 93px;
    }
`;

const Container = styled.div`
    width: 467px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
      width: 100%;
      height: auto;
    }

`;

const MainTitle = styled.h4`
    color: ${theme('palette.weeklySepLeaderboardText')};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
    margin: 3px 0px 15px 0px;
`;


const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 1000px;
    margin: 0 auto;
    height: auto;
`;

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 17px;
    flex-wrap: wrap;
`;

const KeyDetailsSecBox = styled.div`
    width: 48%;
    height: 118px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 1rem 3rem;
    border-radius: 9.192px;
    background: linear-gradient(0deg, #484C00 0%, #484C00 100%), linear-gradient(180deg, #EDE9EE 0%, #C5BABE 100%);

    img {
        width: 61px;
    }

    & p {
        color: #FFF;
        text-align: left;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 133.333% */
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`;

const TermsAndCondition = styled.div`
    width: 848px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 2rem auto;
    border-radius: 14px;
    border: 1px solid #DDD;
    background: rgba(72, 76, 0, 0.50);
    padding: 2rem;
    
    ul {
        list-style: none;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;

        li {
            color: #fff;
            font-size: 16px;
            text-transform: capitalize;
            font-weight: 300;
        }
    }
`;